'use strict'

import css from './searchbar.styles.scss'
import template from './searchbar.template.pug'

export class SearchbarController {
  constructor($scope) {
    'ngInject'
    Object.assign(this, { $scope })
  }

  propagate() {
    this.onChange({ query: this.searchTerm })
  }

  exit() {
    this.onExit()
  }
}

export const umsSearchbar = {
  template: template({ css }),
  transclude: true,
  bindings: {
    onChange: '&',
    onExit: '&',
    placeholder: '@',
  },
  controller: SearchbarController,
}



// WEBPACK FOOTER //
// ./app/shared/components/searchbar/searchbar.component.js